import styles from './blocks.module.css';

/**
 * Shared “regions on this parent” rows (block membership and slide assignment).
 * Add-from-catalog stays block-only in BlockRegionsEditor.
 */
export default function RegionMembershipList({
    items = [],
    emptyText = 'No regions yet.',
    onConfigure,
    onRemove,
    configureLabel = 'Configure details',
    configureTitle,
    removeLabel = 'Remove',
    removeTitle,
    disabled = false,
    hideConfigure = false,
    hideRemove = false,
}) {
    if (!items.length) {
        return <p className={styles.jobText}>{emptyText}</p>;
    }

    return (
        <ul className={styles.inBlockList}>
            {items.map((item) => (
                <li
                    key={item.key}
                    className={`${styles.inBlockRow} ${item.highlighted ? styles.inBlockRowHighlight : ''}`}
                >
                    <span className={styles.inBlockLabel}>{item.label}</span>
                    <span className={styles.inBlockActions}>
                        {!hideConfigure && onConfigure && (
                            <button
                                type="button"
                                className={styles.linkButton}
                                disabled={disabled}
                                title={configureTitle}
                                onClick={() => onConfigure(item)}
                            >
                                {configureLabel}
                            </button>
                        )}
                        {!hideRemove && onRemove && (
                            <button
                                type="button"
                                className={styles.linkButton}
                                disabled={disabled}
                                title={removeTitle}
                                onClick={() => onRemove(item)}
                            >
                                {removeLabel}
                            </button>
                        )}
                    </span>
                </li>
            ))}
        </ul>
    );
}
